// src/components/Timer/TimerDisplay.js

import React from 'react';

function TimerDisplay({ minutes, seconds }) {
  const min = minutes.toString().padStart(2, '0');
  const sec = seconds.toString().padStart(2, '0');

  return <div className="timer-display">{min}:{sec}</div>;
}

export default TimerDisplay;
